import { AccountConfigOptions } from "../AccountConfigOptions/AccountConfigOptions";
import { AccountConfigData } from "~/backend/generated/Configuration/model/accountConfigData";
import { ContextInstance, ContextManager } from "~/modules/contextManager/ContextManager";
import { ConfigurationService } from "~/backend/generated/Configuration/api/configuration.serviceInterface";
import { ConfigurationServiceImpl } from "~/backend/generated/Configuration/api/configuration.service";
import { ClientOptionsStore } from "~/modules/client/ClientOptions/ClientOptionsStore";
import { ErrorCode, ErrorSeverity, FlexSdkErrorMetadata } from "~/modules/error";
import { throwFlexSdkError } from "~/modules/error/ThrowError/ErrorHelper";
import { ClientOptions } from "~/modules/client/Client/Client";

const metadata: FlexSdkErrorMetadata = {
    module: "config",
    severity: ErrorSeverity.Error,
    source: "getAccountConfigData.ts"
};

export const accountConfigProvider =
    (ctx: ContextManager) =>
    async (sessionToken: string, options: AccountConfigOptions = {}): Promise<AccountConfigData> => {
        const configurationService: ConfigurationService = ctx.retrieveInstanceOf(
            ContextInstance.ConfigurationServiceImpl,
            ConfigurationServiceImpl
        );
        const clientOptions: ClientOptions = ctx.retrieveInstanceOf(
            ContextInstance.ClientOptionsStore,
            ClientOptionsStore
        );
        const uiVersion = clientOptions?.accountConfig.query?.UiVersion ?? options?.query?.UiVersion;
        try {
            const config = await configurationService.fetchConfiguration("UiVersion", uiVersion, {
                token: sessionToken
            });
            return config;
        } catch (err) {
            const errorMsg = "getAccountConfigData: Failed to fetch account configuration";
            return throwFlexSdkError(ctx)(ErrorCode.FailedToFetchAccountConfiguration, metadata, errorMsg, err);
        }
    };

export const getAccountConfigData = async (
    sessionToken: string,
    options?: AccountConfigOptions
): Promise<AccountConfigData> => {
    return accountConfigProvider(ContextManager.newInstance())(sessionToken, options);
};
